export const EMAIL_ADMIN_CONSTANTS = Object.freeze({
    DASHBOARD: 'EMAIL_ADMIN__DASHBOARD',
    CONTACTS: 'EMAIL_ADMIN__CONTACTS',
    CONTACT_SAVE: 'EMAIL_ADMIN__CONTACT_SAVE',
    CONTACT_REMOVE: 'EMAIL_ADMIN__CONTACT_REMOVE',
    CONTACT_IMPORT: 'EMAIL_ADMIN__CONTACT_IMPORT',
    IMPORTS: 'EMAIL_ADMIN__IMPORTS',

    LISTS: 'EMAIL_ADMIN__LISTS',
    LIST_GET: 'EMAIL_ADMIN__LIST_GET',
    LIST_SAVE: 'EMAIL_ADMIN__LIST_SAVE',
    LIST_REMOVE: 'EMAIL_ADMIN__LIST_REMOVE',

    TEMPLATES: 'EMAIL_ADMIN__TEMPLATES',
    TEMPLATE_SAVE: 'EMAIL_ADMIN__TEMPLATE_SAVE',
    TEMPLATE_REMOVE: 'EMAIL_ADMIN__TEMPLATE_REMOVE',

    SUPPRESSIONS: 'EMAIL_ADMIN__SUPPRESSIONS',
    SUPPRESSION_SAVE: 'EMAIL_ADMIN__SUPPRESSION_SAVE',
    SUPPRESSION_REMOVE: 'EMAIL_ADMIN__SUPPRESSION_REMOVE',

    CAMPAIGNS: 'EMAIL_ADMIN__CAMPAIGNS',
    CAMPAIGN_GET: 'EMAIL_ADMIN__CAMPAIGN_GET',
    CAMPAIGN_SAVE: 'EMAIL_ADMIN__CAMPAIGN_SAVE',
    CAMPAIGN_REMOVE: 'EMAIL_ADMIN__CAMPAIGN_REMOVE',
    CAMPAIGN_QUEUE: 'EMAIL_ADMIN__CAMPAIGN_QUEUE',
    CAMPAIGN_PAUSE: 'EMAIL_ADMIN__CAMPAIGN_PAUSE',
    CAMPAIGN_RESUME: 'EMAIL_ADMIN__CAMPAIGN_RESUME',
    CAMPAIGN_RETRY_FAILED: 'EMAIL_ADMIN__CAMPAIGN_RETRY_FAILED',
    CAMPAIGN_TEST: 'EMAIL_ADMIN__CAMPAIGN_TEST',
    ATTACHMENT_UPLOAD: 'EMAIL_ADMIN__ATTACHMENT_UPLOAD',
    ATTACHMENT_REMOVE: 'EMAIL_ADMIN__ATTACHMENT_REMOVE',
    RECIPIENTS: 'EMAIL_ADMIN__RECIPIENTS',
});

const C = EMAIL_ADMIN_CONSTANTS;
export const EMAIL_ADMIN_ENDPOINTS = Object.freeze({
    [C.DASHBOARD]: '/email/dashboard',
    [C.CONTACTS]: '/email/contacts',
    [C.CONTACT_SAVE]: '/email/contacts/save',
    [C.CONTACT_REMOVE]: '/email/contacts/remove',
    [C.CONTACT_IMPORT]: '/email/contacts/import',
    [C.IMPORTS]: '/email/imports',

    [C.LISTS]: '/email/lists',
    [C.LIST_GET]: '/email/lists/get',
    [C.LIST_SAVE]: '/email/lists/save',
    [C.LIST_REMOVE]: '/email/lists/remove',

    [C.TEMPLATES]: '/email/templates',
    [C.TEMPLATE_SAVE]: '/email/templates/save',
    [C.TEMPLATE_REMOVE]: '/email/templates/remove',

    [C.SUPPRESSIONS]: '/email/suppressions',
    [C.SUPPRESSION_SAVE]: '/email/suppressions/save',
    [C.SUPPRESSION_REMOVE]: '/email/suppressions/remove',

    [C.CAMPAIGNS]: '/email/campaigns',
    [C.CAMPAIGN_GET]: '/email/campaigns/get',
    [C.CAMPAIGN_SAVE]: '/email/campaigns/save',
    [C.CAMPAIGN_REMOVE]: '/email/campaigns/remove',
    [C.CAMPAIGN_QUEUE]: '/email/campaigns/queue',
    [C.CAMPAIGN_PAUSE]: '/email/campaigns/pause',
    [C.CAMPAIGN_RESUME]: '/email/campaigns/resume',
    [C.CAMPAIGN_RETRY_FAILED]: '/email/campaigns/retry-failed',
    [C.CAMPAIGN_TEST]: '/email/campaigns/test',
    [C.ATTACHMENT_UPLOAD]: '/email/campaigns/attachments/upload',
    [C.ATTACHMENT_REMOVE]: '/email/campaigns/attachments/remove',
    [C.RECIPIENTS]: '/email/recipients',
});
